import api from './AxiosInstance';

export class ImmoService {
 
  getAllImmo = async () => {
    try {
      const response = await api.get(`/Immos/list?perim=IPM`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  getListImmoFam = async () => {
    try {
      const response = await api.get(`/Immos/Familles/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  getListImmoPlan = async () => {
    try {
      const response = await api.get(`/PlanCompta/listAll`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  getDetailImmo = async (code) => {
    try {
      const response = await api.get(`/Immos/Plan/list?code=${code}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  addPassCompta = async (dataPass) => {
    try {
      const response = await api.post(`/Immos/Journal/View`, dataPass , {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };


  addComptaImmo = async (dataPass) => {
    try {
      const response = await api.post(`/Immos/Compta`, dataPass , {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

  AddImmo = async (addData) => {
    try {
      const response = await api.post(`/Immos/add`, addData, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  EddImmo = async (updateData) => {
    try {
      const response = await api.put(`/Immos/update`,updateData, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  deleteImmo = async (code) => {
    try {
      const response = await api.delete(`/Immos/delete/${code}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };

 
}


